
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'
import DssIcon from '@/components/atoms/DssIcon.vue'
import { useRoute, useRouter } from 'vue-router'
export default defineComponent({
  components: {
    DssIcon,
  },
  props: {},
  setup (props, context) {
    const store = useStore()
    const router = useRouter()
    const route = useRoute()

    const tagList = computed(() => {
      return store.getters.myCollectionTagList
    })

    const onTagSelected = (id: number) => {
      store.commit('MY_COLLECTION_SELECTED_TAG', id)
      context.emit('tagSelected')
      router.push({ query: { ...route.query, tagId: id, pageNum: 0 } })
    }

    const tagSelected = computed(() => store.getters.myCollectionSelectedTag)

    return {
      onTagSelected,
      tagSelected,
      tagList,
    }
  },
})
